module.exports = __webpack_public_path__ + "static/media/Syd-Rental_Floorplans_Aug19_2022.e48e0ec8.pdf";